import React, { useState, useEffect } from "react";

import {
  View,
  Text,
  TouchableOpacity,
  Image,
  ScrollView,
} from "react-native";
import { Collapse, CollapseHeader, CollapseBody } from 'accordion-collapse-react-native';
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';

import { FontAwesome5, FontAwesome } from "@expo/vector-icons";
import HeaderTabs from "../../components/HeaderTabs";
import AsyncStorage from '@react-native-async-storage/async-storage';
import api from '../../services/api';

import styles from "./style";
export default function Exchange({ navigation }) {
  const [viewScale] = useState();
  const [pageTab, setPageTab] = useState(0);
  const [tabs, setTabs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectecdAsset, setSelectedAsset] = useState({});

  useEffect(() => {
    getCategories();
  }, [])

  async function getCategories() {
    const token = await AsyncStorage.getItem('JWT_TOKEN');
    api.get('/categories', { headers: { 'Authorization': `Basic ${token}` } })
      .then(response => {
        const categoryTabs = response.data[0].map(item => item.name);
        const categories = response.data[0].map(item => {
          return { id: item.id, name: item.name, description: item.description, path: item.path }
        });
        setTabs(categoryTabs);
        setCategories(categories);
      }).catch((error) => {
        console.log(error);
      });
  }

  const ListActivesCategorie = (itemCategory) => {
    return () => {
      const [activesList, setActivesList] = useState([]);

      const [expanded, setExpanded] = useState(false)

      async function getActivesByCategory(categoryId) {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        return api.get(`/actives/getActives/${categoryId}`, { headers: { 'Authorization': `Basic ${token}` } })
          .then((response) => {
            var listActives = response.data.active.map(item => {
              return { id: item.id, name_token: item.name_token, path: item.path, single_value: item.single_value, cryptoactive: item.cryptoactive }
            })
            return listActives
          })
          .catch((error) => {
            console.log(error);
          })
      }

      useEffect(() => {
        (async () => {
          const list = await getActivesByCategory(itemCategory.id)
          setActivesList(list)
        })()
      }, [itemCategory])
      return (
        <>
          <Collapse style={styles.category} isExpanded={expanded} onToggle={(isExpanded) => setExpanded(isExpanded)}>
            <CollapseHeader style={styles.categoryHeader}>
              <View style={{ width: "100%", flexDirection: "row", justifyContent: "space-between" }}>
                <Text style={styles.categoryTitle}>{itemCategory.name}</Text>
                <Text>{expanded ? "Ocultar" : "Ver informações"}</Text>
              </View>
            </CollapseHeader>
            <CollapseBody style={styles.categoryBody}>
              <Text>{itemCategory.description}</Text>
            </CollapseBody>
          </Collapse>

          <ScrollView horizontal={true} contentContainerStyle={{ justifyContent: "space-between" }} style={styles.assets_list}>
            {activesList.length > 0 && activesList?.map((item) => {
              return (
                <TouchableOpacity
                  key={item.id}
                  onPress={() => handleTokenView(item)}
                >
                  <View style={styles.asset}>
                    <Image source={{ uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}` }} style={styles.asset_icon} />
                    <Text style={styles.asset_name}>{item.name_token}</Text>
                  </View>
                </TouchableOpacity>
              );
            })}
          </ScrollView>
        </>
      )
    }
  }

  const LoadingComponent = () => {
    return (
      <>
        <Text style={{ textAlign: 'center', paddingVertical: 35, fontSize: 16 }}>Carregando</Text>
      </>
    )
  }
  function handleTokenView(token) {
    navigation.navigate("Token", { id: token.id, name: token.name_token, path: token.path, single_value: token.single_value });
    console.log('exchange - ' + token);
  }

  const Tab = createMaterialTopTabNavigator();

  return (
    <View>
      <HeaderTabs
        title={"EXCHANGE"}
        iconLeft={"settings"}
        routeLeft={"MyAccount"}
        subtitle={"Negocie, venda e acompanhe os tokens do mercado"}
      />
      <ScrollView
        style={{
          position: "relative",
          zIndex: -99,
          elevation: 3,
          marginTop: 1,
        }}
      >
        <Text style={styles.pageTitle}>Todos os ativos</Text>
        <ScrollView style={styles.content}>
          <Tab.Navigator tabBarOptions={{
            indicatorStyle: { backgroundColor: '#32BFB1' },
            activeTintColor: '#222',
            inactiveTintColor: 'gray',
          }}>
            {
              categories.length > 0 ?
                categories.map((el, index) =>
                  <Tab.Screen name={el.name} key={index} component={ListActivesCategorie(el)} />
                )
                :
                <Tab.Screen name="Carregando" component={LoadingComponent} />
            }
          </Tab.Navigator>
        </ScrollView>
      </ScrollView>
    </View >
  );
}
